<template>
  <Layout>
    <section class="wrapper">
      <div class="content">
        <div class="header">
          <div class="logo">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
            />
          </div>
          <p class="header-title">PASSPORT ACCOUNT</p>
          <span class="subtitle">Add your photo</span>
        </div>

        <!-- user img  -->
        <div class="user-img">
          <div :class="invalidImage ? 'overlay new-invalid-value' : 'overlay'">
            <image-uploader
              outputFormat="verbose"
              :debug="0"
              :maxWidth="4096"
              :maxHeight="2688"
              :quality="0.7"
              :preview="false"
              :autoRotate="true"
              :capture="false"
              accept="image/*"
              @input="setImage"
              @upload="startImageResize"
              @complete="endImageResize"
            >
              <label for="fileInput" slot="upload-label">
                <div class="d-flex align-items-center">
                  <b-avatar
                    v-if="!imgSpinner"
                    :variant="imageToDisplay ? 'secondary' : 'newlight'"
                    class="user-avatar"
                    :src="imageToDisplay"
                    ><svg
                      v-if="!imageToDisplay"
                      class="camera-icon"
                      width="31"
                      height="26"
                      viewBox="0 0 31 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.65"
                        d="M10.9832 0.769531L9.30717 4.14354H3.02192C1.6291 4.14354 0.507812 5.27212 0.507812 6.67404V22.7006C0.507812 24.1025 1.6291 25.2311 3.02192 25.2311H28.1629C29.5558 25.2311 30.677 24.1025 30.677 22.7006V6.67404C30.677 5.27212 29.5558 4.14354 28.1629 4.14354H21.8777L20.2016 0.769531H10.9832ZM15.5924 8.36104C19.0637 8.36104 21.8777 11.1934 21.8777 14.6873C21.8777 18.1812 19.0637 21.0136 15.5924 21.0136C12.1212 21.0136 9.30717 18.1812 9.30717 14.6873C9.30717 11.1934 12.1212 8.36104 15.5924 8.36104Z"
                        fill="#8C8C8C"
                      />
                    </svg>
                  </b-avatar>
                  <b-spinner
                    class="spinner-grow"
                    v-else
                    type="grow"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  <i class="mdi mdi-camera upload-icon"></i>
                </div>
              </label>
            </image-uploader>
          </div>
        </div>
        <p v-if="invalidImage" class="invalid-image">
          Couldn’t upload your image because it needs to be between 250px -
          4096px width and 300px - 2688px height.
        </p>
        <b-button
          class="upload-btn active-btn"
          :class="uploadBtnClasses()"
          :disabled="getLoading"
          @click="submitFile()"
        >
          <i
            v-if="getLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else> UPLOAD</span></b-button
        >
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/auth";
import PreRegistrationService from "@/services/PreRegistrationService";
import { mapActions } from "vuex";
export default {
  components: {
    Layout,
  },
  data() {
    return {
      imageToDisplay: null, // after converting uploadderFile from dataUrl to base64
      file: null, // after converting image to objFile or dataURL
      imgSpinner: null,
      invalidImage: false,
      getLoading: false,
      journey_flow_id: null,
      hasImage: false,
      update_cloud: false,
    };
  },
  watch: {
    imageToDisplay() {
      this.uploadBtnClasses();
    },
  },
  methods: {
    ...mapActions("user", ["updateImagePreRegAction"]),
    setImage(output) {
      this.imageToDisplay = output.dataUrl;
      if (
        output.info.orgWidth < 250 ||
        output.info.orgWidth > 4096 ||
        output.info.orgHeight < 300 ||
        output.info.orgHeight > 2688
      ) {
        this.invalidImage = true;
      } else {
        this.invalidImage = false;
        this.imgMinSizeErr = false;
        this.hasImage = true;
        const obj = this.dataURLtoFile(output.dataUrl, output.info.name);
        this.file = obj;
      }
    },
    startImageResize() {
      this.imgSpinner = true;
    },
    endImageResize() {
      this.imgSpinner = false;
    },
    handleUpload(event) {
      this.image = event.target;
      if (this.image.files && this.image.files[0]) {
        let reader = new FileReader();
        // convert uploaded file to base64
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(this.image.files[0]);
        // uploaded file
        this.SvImage = this.image.files[0];
      }
    },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },
    uploadBtnClasses() {
      if (this.imageToDisplay && !this.invalidImage) {
        return "active-btn";
      } else if (this.imageToDisplay && this.invalidImage) {
        return "dimmed-btn upload-btn-inv-img";
      } else if (!this.imageToDisplay) {
        return "dimmed-btn ";
      }
    },
    dataURLtoFile(dataUrl, fileName) {
      // convert from dataur to objFile
      let arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },
    submitFile() {
      this.getLoading = true;
      let formData = new FormData();
      const user = JSON.parse(localStorage.getItem("user"));
      formData.append("file", this.file ? this.file : "");
      formData.append("userId", user.data.user.id);
      formData.append("update_cloud", Number(this.update_cloud));

      PreRegistrationService.uploadeImage(formData)
        .then((response) => {
          if (response.data.status === "success") {
            this.updateImagePreRegAction(response.data.data.imgName);
            this.$router.replace("/dashboard");
          }
        })
        .catch((err) => {
          console.log("FAILURE!!", err);

          // for (var pair of formData.entries()) {
          //   console.log(pair[0] + ", " + pair[1]);
          // }

          // if (err.response) {
          //   this.$toast.error(err.response.data.message);
          //   this.getLoading = false;
          // }
        });
    },
  },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.data?.user?.image) {
      console.log(user?.data?.user?.image);
      this.$router.replace("/dashboard");
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 360px;
  margin: 0 auto;
  .content {
    background-color: #fff;
    padding: 73px 25px 0 25px;
    text-align: center;
    .header {
      margin-bottom: 90px;
      .logo {
        width: 116px;
        height: 22px;
        margin: 0 auto 28px;
      }
      .header-title {
        font-family: SF Pro Display;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0em;
        text-align: center;
        margin-bottom: 11px;
      }
      .subtitle {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0em;
        text-align: center;
        color: rgba(0, 0, 0, 0.28);
      }
    }
    .user-img {
      display: flex;
      justify-content: center;
      .overlay {
        transition: opacity 0.5s ease;
        -webkit-transition: opacity 0.5s ease;
        -moz-transition: opacity 0.5s ease;
        position: relative;
        border-radius: 50%;
        z-index: 1;
        margin-bottom: 33px;
        &::after {
          content: "\A";
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.6);
          opacity: 0;
          transition: opacity 0.5s;
          -webkit-transition: opacity 0.5s;
          -moz-transition: opacity 0.5s;
        }
        &:hover {
          &::after {
            opacity: 1;
          }
          .upload-icon {
            display: block;
          }
        }
        div {
          height: 106px;
          .user-avatar,
          .spinner-grow {
            width: 106px;
            height: 106px;
          }
          label {
            margin-bottom: 0px;
          }
        }
      }
    }
    .upload-icon {
      cursor: pointer;
      transition: 0.5s;
      display: none;
      cursor: pointer;
      color: #ffffff;
      opacity: 0.65;
      font-size: 2.5rem;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 3;
      transform: translate(-50%, -50%);
    }
    .user-avatar {
      background-color: #f2f2f2;
      cursor: pointer;
      .imame-posision {
        z-index: -6;
      }
      .camira-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 9;
      }
    }
    .invalid-image {
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.25px;
      color: #f46a6a;
      margin-top: 28px;
      margin-bottom: 35px;
    }
    .upload-btn {
      height: 37px;
      width: 309px;
      border-radius: 18.5px;
      font-family: Lato;
      font-size: 16px;
      font-weight: 500;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: center;
      color: #fff;
      margin-top: 120px;
      margin-bottom: 290px;
    }
    .upload-btn-inv-img {
      margin-top: 90px;
    }
    .active-btn {
      background-color: #103f5e;
      pointer-events: auto;
    }
    .dimmed-btn {
      background-color: #96abb8;
      cursor: not-allowed;
    }
    .custom-file {
      height: 45px;
      width: 130px;
      cursor: pointer;
    }

    .b-avatar-custom {
      position: relative;
    }
  }
}
@media (min-width: 440px) {
  .wrapper {
    width: 590px;
    .content {
      margin: 208px 50px;
      padding: 46px 25px 0 25px;
      border-radius: 26px;
      .header {
        margin-bottom: 52px;
        .logo {
          margin: 0 auto 20px;
        }
        .header-title {
          margin-bottom: 9px;
        }
      }
      .upload-btn {
        height: 44px;
        width: 415px;
        margin: 51px auto 40px;
      }
      .invalid-image {
        width: 310px;
        margin: auto;
      }
      .upload-btn-inv-img {
        margin-top: 51px;
      }
    }
  }
}
</style>